import React from "react";
import ScrollAnimation from "react-animate-on-scroll";
import { FiArrowRight } from "react-icons/fi";
import Logo from "../logo/Logo";
import { Link, useNavigate } from "react-router-dom";

const callToActionData = {
  title: "Ready to start creating a standard website?",
  subtitle:
    "Have a question or want to discuss a project? Reach out to us today! Our team is here to assist you with any inquiries or requests.",
  btnText: "Connect With Us",
};

const CalltoActionSeven = () => {
  const navigate = useNavigate();
  return (
    <div className="rn-callto-action clltoaction-style-default style-7">
      <div className="container">
        <div className="row row--0 align-items-center content-wrapper">
          <div className="col-lg-8 col-md-8">
            <div className="inner">
              <div className="content text-start">
                <Logo
                  image={`${process.env.PUBLIC_URL}/images/mplify/logo/logo-light.png`}
                  image2={`${process.env.PUBLIC_URL}/images/mplify/logo/logo-dark.png`}
                />
                <ScrollAnimation
                  animateIn="fadeInUp"
                  animateOut="fadeInOut"
                  animateOnce={true}
                >
                  <p className="subtitle">{callToActionData.subtitle}</p>
                </ScrollAnimation>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-4">
            <ScrollAnimation
              animateIn="fadeInUp"
              animateOut="fadeInOut"
              animateOnce={true}
            >
              <div className="call-to-btn text-start mt_sm--20 text-md-end">
                <a
                  style={{ cursor: "pointer" }}
                  className="btn-default btn-icon"
                  target=""
                  //href="/contact-us"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/contact-us");
                    window.scrollTo(0, 0);
                  }}
                >
                  {callToActionData.btnText}{" "}
                  <i className="icon">
                    <FiArrowRight />
                  </i>
                </a>
                {/* <Link
                  className="btn-default btn-icon"
                  target=""
                  onClick={(e) => {
                    navigate("/contact-us");
                  }}
                >
                  {callToActionData.btnText}{" "}
                  <i className="icon">
                    <FiArrowRight />
                  </i>
                </Link> */}
              </div>
            </ScrollAnimation>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CalltoActionSeven;
